<template>
    <div class="icon-renderer">
        <icon :icon-name="params.value.icon" />
    </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({});
</script>

<style lang="scss" scoped></style>
